import { CashFlowAdjustmentAmountInput } from 'admin/inputs/CashFlowAdjustmentInput';
import { ClientInput } from 'admin/inputs/ClientInput';
import { DateInput } from 'admin/inputs/DateInput';
import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { Create, getRecordFromLocation, NumberInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { useLocation } from 'react-router-dom';

export const CashFlowAdjustmentCreate: React.FC = () => {
  const location = useLocation();
  const record = getRecordFromLocation(location);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const redirect = (basePath: any, id: any, data: any) => {
    return `Client/${data.client.id}/show/cashFlowAdjustments`;
  };

  return (
    <Create redirect={redirect}>
      <SimpleForm>
        <ClientInput disabled={!!record?.clientId} label="Klient" source="clientId" />
        <TextInput label="Druh" source="text" sx={{ maxWidth: '40em', width: '100%' }} />
        <CashFlowAdjustmentAmountInput label="Suma" required source="period.expectedAmount.amount" />
        <NumberInput label="Opakovať každých" required source="period.periodCount" />
        <SelectInput choices={PERIOD_TYPE_CHOICES} label="" required source="period.periodTypeCode" />
        <DateInput label="Prvá platba" required source="period.referenceDate" />
      </SimpleForm>
    </Create>
  );
};
